// src/components/ui/Icon.jsx
// 재사용 가능한 SVG 아이콘 컴포넌트 라이브러리

import React from 'react';

// 24px 아이콘 맵
import ai24 from '../../assets/icons/24/24_AI.svg';
import back24 from '../../assets/icons/24/24_back.svg';
import calendar24 from '../../assets/icons/24/24_calendar.svg';
import check24 from '../../assets/icons/24/24_check.svg';
import checkCircleFill24 from '../../assets/icons/24/24_check_circle_fill.svg';
import close24 from '../../assets/icons/24/24_close.svg';
import copy24 from '../../assets/icons/24/24_copy.svg';
import download24 from '../../assets/icons/24/24_download.svg';
import file24 from '../../assets/icons/24/24_file.svg';
import floating24 from '../../assets/icons/24/24_Floating.svg';
import folderBlack24 from '../../assets/icons/24/24_Folder_black.svg';
import folder24 from '../../assets/icons/24/24_Folder.svg';
import folding24 from '../../assets/icons/24/24_folding.svg';
import homeBlack24 from '../../assets/icons/24/24_Home_black.svg';
import home24 from '../../assets/icons/24/24_Home.svg';
import paperplane24 from '../../assets/icons/24/24_paperplane.svg';
import paymentBlack24 from '../../assets/icons/24/24_Payment_black.svg';
import payment24 from '../../assets/icons/24/24_Payment.svg';
import plus24 from '../../assets/icons/24/24_plus.svg';
import rename24 from '../../assets/icons/24/24_Rename.svg';
import rotate24 from '../../assets/icons/24/24_rotate.svg';
import sidebar24 from '../../assets/icons/24/24_Sidebar.svg';
import thumbsDown24 from '../../assets/icons/24/24_thumbs_down.svg';
import thumbsUp24 from '../../assets/icons/24/24_thumbs_up.svg';
import top24 from '../../assets/icons/24/24_top.svg';
import trash24 from '../../assets/icons/24/24_trash.svg';
import user24 from '../../assets/icons/24/24_User.svg';
import warning24 from '../../assets/icons/24/24_warning.svg';

// 32px 아이콘 맵
import checkDisable32 from '../../assets/icons/32/32_Check_disable.svg';
import checkFill32 from '../../assets/icons/32/32_check_fill.svg';
import rename32 from '../../assets/icons/32/32_Rename.svg';

// 36px 아이콘 맵
import file36 from '../../assets/icons/36/36_File.svg';

// Special 아이콘 맵
import researchPlanIcon from '../../assets/icons/special/Ico_ Research Plan.svg';
import guidelineIcon from '../../assets/icons/special/Ico_Guideline.svg';
import participantRecruitIcon from '../../assets/icons/special/Ico_Participant recruit.svg';
import participantScreenerIcon from '../../assets/icons/special/Ico_Participant screener.svg';
import resultsAnalysisIcon from '../../assets/icons/special/Ico_Results analysis.svg';
import screeningSurveyIcon from '../../assets/icons/special/Ico_Screening survey.svg';
import surveyAnalysisIcon from '../../assets/icons/special/Ico_Survey Analysis.svg';
import logo32 from '../../assets/icons/special/Logo_32.svg';
import symbol32 from '../../assets/icons/special/Symbol_32.svg';
import sidebarFoldingIcon from '../../assets/icons/Ico_sidebar_folding.svg';

// 아이콘 맵 정의
const iconMap = {
  // 24px 아이콘
  24: {
    ai: ai24,
    back: back24,
    calendar: calendar24,
    check: check24,
    checkCircleFill: checkCircleFill24,
    close: close24,
    copy: copy24,
    download: download24,
    file: file24,
    floating: floating24,
    folder: folder24,
    folderBlack: folderBlack24,
    folding: folding24,
    home: home24,
    homeBlack: homeBlack24,
    paperplane: paperplane24,
    payment: payment24,
    paymentBlack: paymentBlack24,
    plus: plus24,
    rename: rename24,
    rotate: rotate24,
    sidebar: sidebar24,
    thumbsDown: thumbsDown24,
    thumbsUp: thumbsUp24,
    top: top24,
    trash: trash24,
    user: user24,
    warning: warning24,
  },
  // 32px 아이콘
  32: {
    checkDisable: checkDisable32,
    checkFill: checkFill32,
    rename: rename32,
  },
  // 36px 아이콘
  36: {
    file: file36,
  },
  // Special 아이콘
  special: {
    researchPlan: researchPlanIcon,
    guideline: guidelineIcon,
    participantRecruit: participantRecruitIcon,
    participantScreener: participantScreenerIcon,
    resultsAnalysis: resultsAnalysisIcon,
    screeningSurvey: screeningSurveyIcon,
    surveyAnalysis: surveyAnalysisIcon,
    logo: logo32,
    symbol: symbol32,
    sidebarFolding: sidebarFoldingIcon,
  },
};

/**
 * Icon 컴포넌트
 * @param {string} name - 아이콘 이름 (예: 'ai', 'back', 'check')
 * @param {number} size - 아이콘 크기 (24, 32, 36) 또는 'special'
 * @param {string} className - 추가 CSS 클래스
 * @param {object} props - 기타 img 태그 속성들
 */
const Icon = ({ name, size = 24, className = '', ...props }) => {
  const sizeKey = size === 'special' ? 'special' : size;
  const iconSrc = iconMap[sizeKey]?.[name];

  if (!iconSrc) {
    console.warn(`Icon "${name}" with size "${size}" not found`);
    return null;
  }

  return (
    <img
      src={iconSrc}
      alt={name}
      width={size === 'special' ? undefined : size}
      height={size === 'special' ? undefined : size}
      className={className}
      {...props}
    />
  );
};

export default Icon;

// 개별 아이콘 export (편의를 위해)
export const Icon24 = ({ name, ...props }) => <Icon name={name} size={24} {...props} />;
export const Icon32 = ({ name, ...props }) => <Icon name={name} size={32} {...props} />;
export const Icon36 = ({ name, ...props }) => <Icon name={name} size={36} {...props} />;
export const IconSpecial = ({ name, ...props }) => <Icon name={name} size="special" {...props} />;
